import React from 'react';
import IconBase from './IconBase';

const ArrowRightIcon = props => {
    return (
        <IconBase {...props}>
            <path d="M13.6,17.5c-0.2-0.1-0.2-0.3-0.2-0.5c0-0.2,0.1-0.4,0.2-0.5l3.7-3.7H4.9c-0.2,0-0.4-0.1-0.5-0.2c-0.1-0.1-0.2-0.3-0.2-0.5c0-0.2,0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2h12.4l-3.7-3.7c-0.2-0.2-0.2-0.3-0.2-0.5c0-0.2,0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2s0.4,0.1,0.5,0.2l5,5c0.1,0.1,0.1,0.2,0.2,0.2c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.3c0,0.1-0.1,0.2-0.2,0.2l-4.9,4.9c-0.1,0.2-0.3,0.2-0.5,0.2C14,17.7,13.8,17.6,13.6,17.5z"/>
        </IconBase>
    )
}

export default ArrowRightIcon;